import { motion } from "framer-motion";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { StoreButtons } from "./StoreButtons";

const EASE = [0.22, 1, 0.36, 1];

export function AppCallout() {
  const notify = () => toast.success("You're on the list — we'll ping you at launch.");
  return (
    <section id="download" className="mx-auto max-w-7xl scroll-mt-24 px-4 pb-24 sm:px-6 sm:pb-32 lg:px-8">
      <motion.div
        data-testid="app-callout"
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="relative overflow-hidden rounded-3xl border border-acid/25 bg-panel p-8 sm:p-14"
      >
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -left-20 -bottom-24 h-72 w-72 rounded-full bg-acid/10 blur-3xl"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-acid/[0.07] blur-3xl"
        />
        <div className="relative flex flex-col items-center text-center">
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-acid">
            DMWrapped mobile app
          </p>
          <h2 className="mt-3 max-w-xl font-display text-3xl font-bold tracking-tight text-paper sm:text-4xl lg:text-5xl">
            Like what you see? The app goes deeper.
          </h2>
          <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-dim">
            This website is a free taste. The app unlocks the full experience — deeper stats, custom
            story-ready share cards for your close friends, streaks, and new verdicts every time you
            re-run your DMs. Free on iOS and Android.
          </p>
          <div className="mt-8">
            <StoreButtons idPrefix="download" size="lg" center />
          </div>
          <p data-testid="apps-coming-soon-note" className="mt-4 text-[13px] font-medium text-dim">
            iOS & Android apps coming soon
          </p>
          <button
            data-testid="notify-me-button"
            onClick={notify}
            className="mt-5 flex items-center gap-2 rounded-full border border-acid/60 px-6 py-3 text-sm font-bold text-acid transition-all duration-300 hover:bg-acid hover:text-ink"
          >
            <BellRing size={16} /> Notify me at launch
          </button>
        </div>
      </motion.div>
    </section>
  );
}
